module.exports = __webpack_public_path__ + "img/bs.6fab44d3.png";